import { ref, computed } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { autoUpdateSessionStorage } from '@/apps/order/helper';

import { useRouterStore } from '@/apps/order/stores';

import CategoryInterface from '@/apps/order/interfaces/CategoryInterface';

const useOrdersCreateCategoriesStore = defineStore('ordersCreateCategories', () => {
  const routerStore = useRouterStore();
  const { meta } = storeToRefs(routerStore);

  const categories = ref<CategoryInterface[]>();
  autoUpdateSessionStorage(`${meta.value.ctx}.categories`, () => categories.value);

  const isDynamicPower = ref(false);
  autoUpdateSessionStorage(`${meta.value.ctx}.isDynamicPower`, () => isDynamicPower.value);

  const subcategories = computed<Record<string, any>[]>(
    () => categories.value?.reduce((acc: Record<string, any>, item) => {
      acc[item.key] = item.children.map((subcategory) => ({
        label: subcategory.name,
        value: subcategory.key,
      }));
      return acc;
    }, {}) as Record<string, any>[],
  );

  const getByKey = (key: string): CategoryInterface | undefined => (
    (categories.value || []).find((category) => category.key === key)
  );

  return {
    categories,
    isDynamicPower,
    subcategories,
    getByKey,
  };
});

export default useOrdersCreateCategoriesStore;
